import gql from 'graphql-tag';

import { lightCourseCategoryFragment } from '~/shared/graphql-queries/course-categories/course-category-fragment';

export default gql`
  query findByCourseAndIndexCourseCategoryQuery(
    $courseId: MongoID!
    $index: Int!
  ) {
    findByCourseAndIndexCourseCategoryQuery(
      courseId: $courseId
      index: $index
    ) {
      ...LightCourseCategoryFragment
    }
  }
  ${lightCourseCategoryFragment}
`;
